import DefaultDocuments from './DefaultDocuments.view';

export default DefaultDocuments;
